import React from 'react';
import { usePageContentContext } from 'Views/Page/Contexts/PageContentContext';
import { PaginatedCollectionStateProvider } from 'Context/PagedCollectionStateContext';
import { useFQAdminContext } from 'Views/Page/Content/Templates/FQAdminPanel/FQAdminContext';
import { TypeSelector } from 'Views/Page/Content/Templates/FQAdminPanel/TypeSelector';
import { FDBox, FDStack } from '@facet-wealth/design';
import { ItemListContainer } from './ItemListContainer';

const ItemList = () => {
  const { pageContentResource } = usePageContentContext();
  const { listRelationshipName } = useFQAdminContext();

  return (
    <FDBox padding={2} flexGrow={1}>
      <FDStack direction={'column'} flexGrow={1} spacing={4}>
        <TypeSelector resource={pageContentResource} />
        <PaginatedCollectionStateProvider link={pageContentResource.withRelationship(listRelationshipName, (rel) => {
          return rel.link('related');
        }, () => {
          throw new Error(`Unexpected no relationship found on page resource for ${listRelationshipName}`);
        })}
        >
          <ItemListContainer />
        </PaginatedCollectionStateProvider>
      </FDStack>
    </FDBox>
  );
};

export { ItemList };
